
// export default Header;
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./HeaderFooter.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle Scroll Effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Helper to close menu when a link is clicked
  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <header className={`header_1 ${scrolled ? "scrolled" : ""}`}>
        
        {/* --- Desktop Left --- */}
        <nav className="nav-left">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/About" className="nav-link">About Us</Link>
          <Link to="/Classes" className="nav-link">Classes</Link>
        </nav>

        {/* --- Center Logo --- */}
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img 
              src="/images/logom.png" 
              alt="Satvic Path Logo" 
              className="logo-img" 
            />
          </Link>
        </div>

        {/* --- Desktop Right --- */}
        <nav className="nav-right">
          <Link to="/blogs" className="nav-link">
            Blogs
          </Link>
          <Link to="/product" className="nav-link">Products</Link>
          <Link to="/contact">
            <button className="head-contact-btn">Contact Us</button>
          </Link>
        </nav>

        {/* --- Mobile Hamburger --- */}
        <div className="hamburger" onClick={toggleMenu}>
          ☰
        </div>
      </header>

      {/* --- Mobile Side Drawer --- */}
      
      {/* Backdrop Overlay */}
      {isOpen && <div className="overlay" onClick={closeMenu}></div>}

      {/* Drawer Content */}
      <div className={`side-menu ${isOpen ? "open" : ""}`}>
        <button className="head-close-btn" onClick={closeMenu}>×</button>

        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/About" onClick={closeMenu}>About Us</Link>
        <Link to="/Classes" onClick={closeMenu}>Classes</Link>
        <Link to="/blogs" onClick={closeMenu}>Blogs</Link>
        <Link to="/product" onClick={closeMenu}>Products</Link>
        <Link to="/contact" onClick={closeMenu}>
          <button className="head-contact-btn" style={{width: '100%', marginTop: '10px'}}>
            Contact Us
          </button>
        </Link>
      </div>
    </>
  );
};

export default Header;